export const analyticsRoutes = {
  overview: "",
  adoptionDetails: "adoption",
  contributionDetails: "contribution",
  engagementDetails: "engagement",
  bookingReporting: "bookings",
  communityFeedReporting: "community-feed",
  communityFeedSentimentReporting: "community-feed/sentiment",
  eventReporting: "events",
  ticketReporting: "tickets",
  explore: "explore",
  exploreAdoption: "explore/adoption",
  exploreEngagement: "explore/engagement",
  exploreContribution: "explore/contribution",
  exploreEvents: "explore/events",
  exploreBookings: "explore/bookings",
  exploreCommunityFeed: "explore/community-feed",
  exploreSentiment: "explore/sentiment",
  exploreTickets: "explore/tickets",
} as const;

export type AnalyticsRouteParams = {
  overview: {
    "esg-date-range"?: string;
    "tickets-date-range"?: string;
  };
};
